/** The process view's page for a department whose floating seats are all in use (`SeatUnavailableState`). The words about the seats are `seats.unavailable`. */
export default {
	seat: {
		tryAgain: "Try again",
		openDepartment: "Open {department}",
	},
};
